import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Dialog } from "@fluentui/react/lib/Dialog";

import { IImageCarouselProps } from "./IImageCarouselProps";
import { useContentStyles } from "./UseImageCarouselStyles";

export function ImageCarousel({
  imgList, isModalOpen, hideModal, selectedImg
}: IImageCarouselProps): JSX.Element {
  const styles = useContentStyles();
  return (
    <Dialog
      hidden={!isModalOpen}
      dialogContentProps={{
        showCloseButton: true,
        className: styles.content
      }}
      onDismiss={hideModal}
      modalProps={{ className: styles.modal, isDarkOverlay: true, isBlocking: false }}
    >
      <Carousel
        className={styles.carousel}
        selectedItem={selectedImg}
        showThumbs={false}
        dynamicHeight
        statusFormatter={(currentItem, total) => `${currentItem}/${total}`}
      >
        {imgList.map((src) => (
          <img key={src} src={src} />
        ))}
      </Carousel>
    </Dialog>
  );
}
